import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { FdeCopy } from '@/frontend/features/Fde/types'

export default function ProjectTaskMonthNavigation({
  month,
  offset,
  onOffset,
  hint,
  copy,
}: {
  month: Date
  offset: number
  onOffset: (value: number) => void
  hint: string
  copy: FdeCopy
}) {
  return (
    <div className="mb-4 flex items-center justify-between gap-3">
      <div>
        <h3 className="text-sm font-semibold capitalize">
          {new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(month)}
        </h3>
        <p className="mt-1 max-w-md text-xs text-muted-foreground">{hint}</p>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={copy.management.previous_month}
          onClick={() => onOffset(offset - 1)}
        >
          <ChevronLeft />
        </Button>
        <Button variant="outline" size="sm" onClick={() => onOffset(0)}>
          {copy.management.current_month}
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={copy.management.next_month}
          onClick={() => onOffset(offset + 1)}
        >
          <ChevronRight />
        </Button>
      </div>
    </div>
  )
}
